import styled from "styled-components";

const Label = styled.label`
  position: relative;
  border-radius: 24px;
  border: ${props =>
    props.checked ? "solid 1px #bab1ff" : "solid 1px #e6e8f0;"};
  background-color: #ffffff;
  padding: 12px 16px;
  transition: all 300ms ease-out;
  cursor: pointer;

  :before {
    content: " ";
    display: block;
    opacity: ${props => (props.checked ? 1 : 0)};
    position: absolute;
    width: calc(100% + 6px);
    border-radius: 42px;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    border: 2px solid rgba(186, 177, 255, 0.3);
  }

  :hover {
    border-color: ${props => (props.checked ? "#bab1ff" : "#ccd2e1;")};
  }

  box-shadow: ${props =>
    props.checked ? "0 4px 20px 0 rgba(34, 41, 57, 0.15)" : "unset"};
`;

// Hide checkbox visually but remain accessible to screen readers.
const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  text-align: left;
`;

const Content = styled.span`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const Title = styled.div`
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  img {
    margin-right: 5px;
  }
`;

export { Label, HiddenCheckbox, CheckboxContainer, Content, Title };



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/quickFilters/QuickFilterStyle.js